/** Read mark fields from published result API rows (PascalCase or camelCase). */
export function readPublishedResultField(row, field) {
  if (!row) {
    return null;
  }

  const direct = row[field];
  if (direct !== null && direct !== undefined && direct !== "") {
    return direct;
  }

  const jsonNetCamel = field.charAt(0).toLowerCase() + field.slice(1);
  const alt = row[jsonNetCamel];
  if (alt !== null && alt !== undefined && alt !== "") {
    return alt;
  }

  return null;
}

export function formatPublishedMark(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return Number(value).toFixed(2);
}
